import { defineStore } from 'pinia';
import { ref, watch } from 'vue';
import api from '@/api/axios.js';
import { useAuthStore } from './auth.js';

export const useThemeStore = defineStore('theme', () => {
  const ALLOWED_THEMES = ['dark', 'light'];
  const DEFAULT_THEME = 'dark';

  function resolveTheme(value) {
    return ALLOWED_THEMES.includes(value) ? value : DEFAULT_THEME;
  }

  const theme = ref(resolveTheme(localStorage.getItem('theme') || DEFAULT_THEME));

  const THEME_COLOR = { dark: '#000000', light: '#f4f4f5' };

  function apply(t) {
    document.documentElement.setAttribute('data-theme', t);

    let meta = document.querySelector('meta[name="theme-color"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', 'theme-color');
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', THEME_COLOR[t]);
  }

  async function setTheme(nextTheme, options = {}) {
    const { syncBackend = true } = options;
    const safeTheme = resolveTheme(nextTheme);
    theme.value = safeTheme;

    if (!syncBackend) return;

    try {
      const auth = useAuthStore();
      if (!auth.isLoggedIn) return;

      await api.post('/auth/set-theme', { theme: safeTheme });

      if (auth.user) {
        auth.user = { ...auth.user, theme: safeTheme };
        localStorage.setItem('user', JSON.stringify(auth.user));
      }
    } catch (err) {
      console.error('Fehler beim Speichern des Themes:', err.message);
    }
  }

  function toggle() {
    const next = theme.value === 'dark' ? 'light' : 'dark';
    void setTheme(next);
  }

  function init() {
    apply(theme.value);
  }

  // Sofort anwenden + bei Änderung speichern
  init();
  watch(theme, (t) => {
    apply(t);
    localStorage.setItem('theme', t);
  });

  return { theme, toggle, setTheme, init };
});